module.exports = __webpack_public_path__ + "static/media/figure11.a0f83b1c.png";